import React from "react";
import {
  WMS_PBF_DAFTAR_MUTASI_ITEM,
  WMS_PBF_DAFTAR_PO,
  WMS_PBF_FORECASTING,
  WMS_PBF_HISTORY_STOK,
  WMS_PBF_INPUT_REQUEST_MUTASI,
  WMS_PBF_INVENTORY_CONTROL,
  WMS_PBF_KARTU_STOK,
  WMS_PBF_LAP_PEMBELIAN,
  WMS_PBF_LPF_LAPORAN_HISTORY_NARKOTIK,
  WMS_PBF_MS_BARANG,
  WMS_PBF_MS_FORMULA,
  WMS_PBF_MS_FORMULA_HARGA,
  WMS_PBF_MS_GOLONGAN_OBAT,
  WMS_PBF_MS_GUDANG,
  WMS_PBF_MS_JENIS_HARGA,
  WMS_PBF_MS_JENIS_OBAT,
  WMS_PBF_MS_KELAS_TERAPI,
  WMS_PBF_MS_TARIF_CBG,
  WMS_PBF_MUTASI_ITEM,
  WMS_PBF_PO,
  WMS_PBF_RECEIVE_REQUEST_MUTASI,
  WMS_PBF_RETUR_PEMBELIAN,
  WMS_PBF_TRACKING_NARKOTIK,
  WMS_SERVICE_TUTUP_PEMBELIAN,
} from "App/constants";
import {
  DaftarInventoryControl,
  DaftarMutasiItemPerbekalanFarmasi,
  ForecastingFarmasi,
  HistoryStokFarmasi,
  InputReceiveMutasi,
  InputRequestMutasi,
  KartuStokFarmasi,
  LaporanNarkotik,
  MutasiItem,
  ReturPembelianPerbekalanFarmasi,
  ServiceTutupPembelian,
  TrackingNarkotik,
  WfDaftarPurchaseOrderPage,
  WfLaporanPembelianPage,
  WfMasterBarangPage,
  WfMasterFormulaHargaPage,
  WfMasterFormulaPage,
  WfMasterGolonganObatPage,
  WfMasterGudangPage,
  WfMasterJenisHargaPage,
  WfMasterJenisObatPage,
  WfMasterKelasTerapiPage,
  WfMasterTarifCbgPage,
  WfPurchaseOrderPage,
} from "../WrapperLazyExport";

export const menuFarmasi = {
  [WMS_PBF_PO]: <WfPurchaseOrderPage />,
  [WMS_PBF_DAFTAR_PO]: <WfDaftarPurchaseOrderPage />,
  [WMS_PBF_LAP_PEMBELIAN]: <WfLaporanPembelianPage />,

  [WMS_PBF_MS_GUDANG]: <WfMasterGudangPage />,
  [WMS_PBF_MS_FORMULA_HARGA]: <WfMasterFormulaHargaPage />,
  [WMS_PBF_MS_TARIF_CBG]: <WfMasterTarifCbgPage />,
  [WMS_PBF_MS_BARANG]: <WfMasterBarangPage />,
  [WMS_PBF_MS_KELAS_TERAPI]: <WfMasterKelasTerapiPage />,
  [WMS_PBF_MS_GOLONGAN_OBAT]: <WfMasterGolonganObatPage />,
  [WMS_PBF_MS_FORMULA]: <WfMasterFormulaPage />,
  [WMS_PBF_MS_JENIS_HARGA]: <WfMasterJenisHargaPage />,
  [WMS_PBF_MS_JENIS_OBAT]: <WfMasterJenisObatPage />,

  [WMS_PBF_INVENTORY_CONTROL]: <DaftarInventoryControl />,
  [WMS_PBF_DAFTAR_MUTASI_ITEM]: <DaftarMutasiItemPerbekalanFarmasi />,
  [WMS_PBF_MUTASI_ITEM]: <MutasiItem />,
  [WMS_PBF_RETUR_PEMBELIAN]: <ReturPembelianPerbekalanFarmasi />,
  [WMS_PBF_TRACKING_NARKOTIK]: <TrackingNarkotik />,
  [WMS_PBF_INPUT_REQUEST_MUTASI]: <InputRequestMutasi />,
  [WMS_PBF_RECEIVE_REQUEST_MUTASI]: <InputReceiveMutasi />,
  [WMS_PBF_LPF_LAPORAN_HISTORY_NARKOTIK]: <LaporanNarkotik />,
  [WMS_PBF_HISTORY_STOK]: <HistoryStokFarmasi />,
  [WMS_PBF_KARTU_STOK]: <KartuStokFarmasi />,
  [WMS_PBF_FORECASTING]: <ForecastingFarmasi />,
  [WMS_SERVICE_TUTUP_PEMBELIAN]: <ServiceTutupPembelian />,
};
